export const searchConstant = {
  SEARCH_KEY_REQUEST: "SEARCH_KEY_REQUEST",
  SEARCH_KEY_SUCCESS: "SEARCH_KEY_SUCCESS",
  SEARCH_KEY_FAILURE: "SEARCH_KEY_FAILURE",
  SEARCH_RANKING_KEY_REQUEST: "SEARCH_RANKING_KEY_REQUEST",
  SEARCH_RANKING_KEY_SUCCESS: "SEARCH_RANKING_KEY_SUCCESS",
  SEARCH_RANKING_KEY_FAILURE: "SEARCH_RANKING_KEY_FAILURE",
};
